import React from 'react';
import LabelTag from './LabelTag';
import { useMutation, useQuery } from 'react-apollo';
import { Mutations, Queries } from 'gql';
import generateOffset from '../NotesTab/generateOffset';

const QuickAdd = ({ metro, phaseId }) => {
  const [addCustomLabel] = useMutation(Mutations.ADD_CUSTOM_LABEL);
  const { data } = useQuery(Queries.GET_QUICK_ADD_LABELS);
  const quickAddLabel = async (label) => {
    await addCustomLabel({
      variables: {
        phaseId,
        metroCode: metro.code,
        labelOffset: generateOffset(metro.customLabels.length),
        value: label.value,
        imgUrl: label.img,
      },
    });
  };
  return (
    <>
      <span className="label-title">QUICK ADD:</span>
      <div className="tags-container">
        {data?.quickAddLabels?.map((label) => (
          <LabelTag key={label.id} quickAddLabel={quickAddLabel} label={label} />
        ))}
      </div>
    </>
  );
};

export default QuickAdd;
